import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

import { useIsMobile } from "../../AppLayout/useResponsive";

/**
 * Single source of truth for whether the inline mobile header menu button is
 * active: a mobile viewport with the `MOBILE_HEADER_MENU_BUTTON` flag on. When
 * active, pages render the inline hamburger and `AppLayoutMobile` suppresses the
 * bottom-right floating button.
 */
export function useIsHeaderMenuButtonEnabled(): boolean {
  const isMobile = useIsMobile();
  const isEnabled = useCbhFlag(CbhFeatureFlag.MOBILE_HEADER_MENU_BUTTON, { defaultValue: false });

  return isMobile && isEnabled;
}
